// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".go-back-button{align-items:center;display:flex}.go-back-button__icon{height:20px;width:20px}@media(min-width:1024px){.go-back-button__icon{height:12px;width:12px}}.go-back-button__text{display:none;margin:0 0 0 var(--spacing-smallest)}@media(min-width:1024px){.go-back-button__text{display:inline-block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
